import {Component, HostListener , Inject, OnDestroy, OnInit} from '@angular/core';
import {environment} from '../../environments/environment.local';
import {
  ComplianceServiceToken,
  ComplianceService
} from './services/compliance-notification-service';
import {overviewPageRoute} from '../shared/routes';
import {Router} from '@angular/router';

@Component({
  selector: 'app-compliance-notice',
  templateUrl: './compliance-notice.component.html',
  styleUrls: ['./compliance-notice.component.scss']
})
export class ComplianceNoticeComponent implements OnInit, OnDestroy {
  complianceUrl: string;
  enableCompliance: boolean;

  constructor(
    @Inject(ComplianceServiceToken) private readonly complianceNoticeService: ComplianceService,
    private router: Router
  ) {
    this.enableCompliance = !!environment.enableCompliance;
  }
  ngOnInit() {
    if (this.enableCompliance) {
      this.complianceUrl = `${environment.complianceUrl}/getnotificationsuser/42/CPSCAnalytics/?clearToken=true`;
    }
  }

  ngOnDestroy() {
    if (this.enableCompliance) {
      window.removeEventListener('message', this.handleEvent);
    }
  }
  @HostListener('window:message', ['$event'])
  handleEvent(event: MessageEvent) {
    if (event.origin !== environment.complianceUrl || !event.data || !this.enableCompliance) {
      return;
    }
    this.complianceNoticeService.notificationsAccepted = event.data;
    if (typeof event.data === 'boolean' && event.data === true) {
      this.router.navigate([overviewPageRoute]);
    }
  }
}

